import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Button, Form, DatePicker } from 'antd';
import moment from 'moment';
import ExcelJS from 'exceljs';
import { reportDailyHourRequest } from '~/store/modules/reports/dailyHour/actions';
import { Container } from './styles';
import { FilterContent } from '../../Sprint/styles';

export default function DailyHour() {
  const dispatch = useDispatch();
  const loading = useSelector(store => store.reportDailyHour.loading);
  const result = useSelector(store => store.reportDailyHour.result);

  const [processed, setProcessed] = useState(false);
  const [report, setReport] = useState([]);
  const [form] = Form.useForm();

  function onFinish(values) {
    const { startAt } = values;
    const filters = [{ startAt: moment(startAt).format('YYYY-MM-DD') }];
    setProcessed(false);
    dispatch(reportDailyHourRequest(filters));
  }

  useEffect(() => {
    setReport([]);
  }, [])

  useEffect(() => {
    if (!loading && result.length > 0 && !processed) {
      setReport(result);
      setProcessed(true);
    }
  }, [result, loading, processed]);

  useEffect(() => {
    if (!processed || report.length === 0) return;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Relatório Diário');

    worksheet.columns = [
      { header: 'Project', key: 'Project', width: 20 },
      { header: 'Task', key: 'Task', width: 50 },
      { header: 'CompletedWork', key: 'CompletedWork', width: 15 },
      { header: 'TimeWorked', key: 'TimeWorked', width: 15 },
    ];

    report.forEach(item => worksheet.addRow(item));

    workbook.xlsx.writeBuffer()
      .then((buffer) => {
        const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `relatorio_${moment().format('YYYY-MM-DD_HH-mm')}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      })
      .catch((err) => {
        console.error('Erro ao gerar Excel:', err);
      });
  }, [processed, report]);

  return (
    <Container>
      <h2>Relatório Diário de Horas</h2>
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Row gutter={8}>
          <Col xs={24} sm={12} md={6} lg={4}>
            <Form.Item
              label="Dia"
              name="startAt"
              rules={[{ required: true, message: 'Dia é obrigatório' }]}
            >
              <DatePicker format="DD/MM/YYYY" placeholder="" />
            </Form.Item>
          </Col>
          <Col xs={24} md={4} lg={8}>
            <Form.Item noStyle>
              <FilterContent style={{ marginTop: 24, padding: 0 }}>
                <Button htmlType="submit" type="primary" loading={loading}>
                  Gerar relatório
                </Button>
              </FilterContent>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Container>
  );
}